import React, { Fragment, useState, useEffect } from 'react';
import { Link, useParams, useMatch, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createUser, getUserById } from '../../actions/user';
import { setAlert } from '../../actions/alert';
import Spinner from '../layout/Spinner';
import { useTranslation, Trans } from 'react-i18next';
import { GrCircleInformation } from 'react-icons/gr';

const initialState = {
  name: '',
  identifiant: '',
  rights: '',
  password: '',
  password2: ''
};

const UserEdit = ({
  setAlert,
  auth,
  user: { user, loading },
  createUser,
  getUserById,
  history
}) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState(initialState);
  const [action, setaction] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const creatingUser = useMatch('/create-user');

  useEffect(() => {
    if (!user && !creatingUser) {
      getUserById(id);
    }
    if (!loading) {
      if (!creatingUser) {
        const userData = { ...initialState };
        for (const key in user) {
          if (key in userData) userData[key] = user[key];
        }
        setFormData(userData);
      } else {
        if (auth.user.rights === 'admin') {
          const userData = { ...initialState };
          userData.rights = 'user';
          setFormData(userData);
        }
      }
    }
  }, [loading, user, id, getUserById, creatingUser]);

  const { name, identifiant, phone, rights, password, password2 } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!creatingUser && password !== password2) {
      setAlert(<Trans>{t('password_match_err')}</Trans>, 'danger');
    } else if (!creatingUser && password.length > 0 && password.length < 6) {
      setAlert(<Trans>{t('password_6_error')}</Trans>, 'danger');
    } else {
      const res = await createUser(user ? user._id : null, formData, history);

      if (res && res.status === 200) {
        setaction(true);
        if (auth.user.rights === 'user') {
          setTimeout(() => {
            navigate(`/user/${user._id}`);
          }, 1000);
        } else {
          if (creatingUser) {
            setTimeout(() => {
              navigate('/users');
            }, 5000);
          } else {
            setTimeout(() => {
              navigate('/users');
            }, 1000);
          }
        }
      }
    }
  };

  return (
    <section className="container">
      <Fragment>
        {action ? (
          <div>
            {action && creatingUser ? (
              <div
                className="card-header-color text-center"
                style={{ marginTop: '1rem' }}
              >
                <GrCircleInformation size={40} color="grey" />
                <p className="lead" style={{ marginTop: '1rem' }}>
                  {t('activation_email_sent')}
                </p>
              </div>
            ) : (
              <Spinner />
            )}
          </div>
        ) : (
          <Fragment>
            {auth.user.rights === 'admin' || auth.user.rights === 'user' ? (
              <Fragment>
                <h2 className="large text-ascorel">
                  {creatingUser ? (
                    <Trans>{t('create_account_title')}</Trans>
                  ) : (
                    <Trans>{t('mod_account_title')}</Trans>
                  )}
                </h2>
                <p className="lead">
                  <i className="fas fa-user" />
                  {creatingUser ? (
                    <Trans>{t('creer_code_lead')}</Trans>
                  ) : (
                    <Trans>{t('mod_account_lead')}</Trans>
                  )}
                </p>
                <small>{t('champs_requis')}</small>
                <form className="form" onSubmit={onSubmit}>
                  <div className="form-group">
                    <input
                      type="email"
                      placeholder={t('ph_email')}
                      name="identifiant"
                      value={identifiant}
                      onChange={(e) => onChange(e)}
                      required
                    />
                    <small className="form-text">{t('must_unique')}</small>
                  </div>
                  <div className="form-group">
                    <select
                      name="rights"
                      value={rights}
                      required
                      onChange={(e) => onChange(e)}
                    >
                      <option value="">{t('rights_select')}</option>
                      {auth.user.rights === 'admin' ? (
                        <Trans>
                          <option value="admin">{t('rights_admin')}</option>
                        </Trans>
                      ) : null}
                      <option value="user">{t('rights_user')}</option>
                    </select>
                    <small className="form-text">{t('rights_hint')}</small>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder={t('name_ph')}
                      name="name"
                      value={name}
                      onChange={onChange}
                    />
                    <small className="form-text">{t('name_hint')}</small>
                  </div>
                  {!creatingUser ? (
                    <div>
                      <div className="form-group">
                        <input
                          type="password"
                          placeholder={t('pass_ph')}
                          name="password"
                          value={password}
                          onChange={(e) => onChange(e)}
                        />
                        <small className="form-text">{t('pass_hint')}</small>
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          placeholder={t('pass2_ph')}
                          name="password2"
                          value={password2}
                          onChange={(e) => onChange(e)}
                        />
                        <small className="form-text">{t('pass2_hint')}</small>
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {creatingUser ? (
                    <>
                      <input
                        type="submit"
                        className="btn btn-ascorel my-1"
                        value={t('create')}
                      />
                      <Link className="btn btn-light my-1" to="/users">
                        {t('cancel')}
                      </Link>
                    </>
                  ) : (
                    <>
                      <input
                        type="submit"
                        className="btn btn-ascorel my-1"
                        value={t('save')}
                      />
                      <Link
                        className="btn btn-light my-1"
                        to={`/user/${user._id}`}
                      >
                        {t('cancel')}
                      </Link>
                    </>
                  )}
                </form>
              </Fragment>
            ) : (
              <p>{t('unauthorized_access')}</p>
            )}
          </Fragment>
        )}
      </Fragment>
    </section>
  );
};

UserEdit.propTypes = {
  createUser: PropTypes.func.isRequired,
  getUserById: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user,
  auth: state.auth
});

export default connect(mapStateToProps, {
  createUser,
  getUserById,
  setAlert
})(UserEdit);
